import jsyaml from 'js-yaml';
import reader from '@/file/blob-file-item-reader';
import ScaffoldConfigValidator from './scaffold-config-validator';
import ScaffoldSampleValidator from './scaffold-sample-validator';

export default class ScaffoldConfig {
  static validateBlobFiles(configBlobFile, sampleBlobFile) {
    return reader.read(configBlobFile).then((file) => {
      let config = null;
      try {
        config = jsyaml.safeLoad(file.content);
        if (!config) {
          throw new Error('File is empty!');
        }
      } catch (err) {
        throw new Error(`Error on scaffoldhub/config.yml: ${err.message}`);
      }

      return this.validateConfig(config).then(() => {
        if (sampleBlobFile == null) {
          return Promise.resolve();
        }

        return reader.read(sampleBlobFile).then((sampleFile) => {
          const sample = JSON.parse(sampleFile.content);
          return this.validateSample(sample, config);
        });
      });
    });
  }

  static validateConfig(config) {
    return new Promise((resolve, reject) => {
      const validator = new ScaffoldConfigValidator(config);
      try {
        validator.validate();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  static validateSample(sample, config) {
    return new Promise((resolve, reject) => {
      const validator = new ScaffoldSampleValidator(sample, config);
      try {
        validator.validate();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}
